var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateLibraryGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5872H18V2.14687H16V9.40371L13.5 7.84867L11 9.40371V2.14687H6V14.5872ZM6 16.6605C5.45 16.6605 4.97917 16.4575 4.5875 16.0515C4.19583 15.6454 4 15.1573 4 14.5872V2.14687C4 1.57669 4.19583 1.08858 4.5875 0.682542C4.97917 0.276505 5.45 0.0734863 6 0.0734863H18C18.55 0.0734863 19.0208 0.276505 19.4125 0.682542C19.8042 1.08858 20 1.57669 20 2.14687V14.5872C20 15.1573 19.8042 15.6454 19.4125 16.0515C19.0208 16.4575 18.55 16.6605 18 16.6605H6ZM2 20.8073C1.45 20.8073 0.979167 20.6043 0.5875 20.1983C0.195833 19.7922 0 19.3041 0 18.7339V4.22025H2V18.7339H16V20.8073H2Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateLibraryGreen);
export default __webpack_public_path__ + "static/media/template-library-green.031ced96ea43b77ef03979e517ea3261.svg";
export { ForwardRef as ReactComponent };